import React, { useEffect, useRef } from 'react';
import { Chart, RadarController, RadialLinearScale, PointElement, LineElement, Filler, Tooltip, Legend } from 'chart.js';

// Register required chart.js components
Chart.register(RadarController, RadialLinearScale, PointElement, LineElement, Filler, Tooltip, Legend);

const SpiderChart = () => {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');

    // Sample Data
    const data = {
      labels: ['Speed', 'Agility', 'Strength', 'Endurance', 'Flexibility'],
      datasets: [
        {
          label: 'Athlete A',
          data: [8, 9, 6, 7, 8],
          backgroundColor: 'rgba(255, 99, 132, 0.2)',
          borderColor: 'rgba(255, 99, 132, 1)',
          borderWidth: 2,
        },
        {
          label: 'Athlete B',
          data: [7, 6, 8, 9, 7],
          backgroundColor: 'rgba(54, 162, 235, 0.2)',
          borderColor: 'rgba(54, 162, 235, 1)',
          borderWidth: 2,
        },
      ],
    };

    // Chart options with white text and larger font
    const options = {
      scales: {
        r: {
          angleLines: {
            color: 'yellow', // Change web lines color to yellow
            display: true,
          },
          grid: {
            color: 'yellow', // Change grid lines color to yellow
          },
          suggestedMin: 0,
          suggestedMax: 10,
          ticks: {
            color: 'white',
            font: {
              size: 16,
            },
          },
          pointLabels: {
            color: 'white',
            font: {
              size: 16,
            },
          },
        },
      },
      plugins: {
        legend: {
          position: 'top',
          labels: {
            color: 'white',
            font: {
              size: 14,
            },
          },
        },
      },
    };

    // Create radar chart
    const chart = new Chart(ctx, {
      type: 'radar',
      data: data,
      options: options,
    });

    // Cleanup chart instance on unmount
    return () => {
      chart.destroy();
    };
  }, []);

  return (
    <div className="w-full flex justify-center min-h-[300vh]">
      <canvas ref={canvasRef} width={300} height={300}></canvas>
    </div>
  );
};

export default SpiderChart;
